import type { Ref } from 'react';
import { forwardRef } from 'react';

import { ReactComponent as ChevronLeft } from '@/assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRight } from '@/assets/icons/chevron-right.svg';

import * as S from './BoutiqueStorySlider.styles';

const MAPPING = {
  next: <ChevronRight />,
  prev: <ChevronLeft />,
};

type NavigationProps = { type: 'next' | 'prev' };

export const Navigation = forwardRef(
  ({ type }: NavigationProps, ref: Ref<HTMLSpanElement>) => {
    return (
      <S.Navigation ref={ref} className={type} type={type}>
        {MAPPING[type]}
      </S.Navigation>
    );
  },
);

Navigation.displayName = 'Navigation';
